<script>
import Footer from "@/components/Footer";

export default {
  name: "LearnMore",
  //router,
  components: {
    Footer
  },
  data() {
    return {
      isSticky: false,
      stickyClass: "is_sticky",
      scrollPosition: 0
    };
  },
  created() {
    try {
      this.checked = localStorage.getItem("mode") === "false" ? true : false;
    } catch (e) {
      this.checked = false;
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollPosition = window.scrollY;
      if (this.scrollPosition >= 50) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    }
  }
};
</script>

<style scoped>
.navbar-custom {
  font-size: 2rem;
  font-weight: 700;
  background: #fff;
  box-shadow: 0 0 21px rgb(0 0 0 / 20%);
  position: relative;
  z-index: 99;
  padding: 10px;
}
.navbar-custom.isSticky {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  width: 100%;
  /* width: calc(100% - 320px); */
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
  /* -webkit-animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
  animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1); */
}
.darkmode .navbar-custom.isSticky {
  background-color: #180f4f !important;
  border-color: #180f4f !important;
  top: -24px;
  transform: translateY(24px);
  transition: transform 0.4s;
}
.darkmode .navbar-custom,
.darkmode .navbar-light,
.darkmode .navbar {
  background: #1e2041 !important;
}
.darkmode .navbar-custom .light-logo,
.darkmode .navbar-light .light-logo,
.darkmode .navbar .light-logo,
.dark-logo {
  display: none;
}
.darkmode .navbar-custom .dark-logo,
.darkmode .navbar-light .dark-logo,
.darkmode .navbar .dark-logo {
  display: block;
}
.navbar-logo a img {
  max-height: 80px;
}
.learn-heading h4 {
  color: #5e5ca9;
  font-weight: 600;
  margin-bottom: 30px;
}
.darkmode .learn-heading h4 {
  color: #dcdaec;
}
.learn-subheading h5,
.learn-subheading h2 {
  color: #000;
  font-weight: 600;
  margin-bottom: 20px;
}
.darkmode .learn-subheading h5,
.darkmode .learn-subheading h2 {
  color: #cecece;
}
.list-style li {
  list-style-type: disc;
  margin-bottom: 15px;
  font-size: 14px;
}
.darkmode .list-style li,
.darkmode p,
.darkmode p strong {
  color: #b5b5b5;
}
@media screen and (max-width: 767px) {
  .navbar-logo a img, 
    .navbar-logo img, 
    .navbar-logo-customer img, 
    /* .navbar-logo-customer a img {
        max-height: 60px;
        min-height: 60px;
    } */
    .learn-heading h4 {
    font-size: 1rem;
    /* margin-bottom: 8px; */
    color: #180f4f;
  }
  .learn-subheading h5 {
    font-size: 0.9rem;
    margin-bottom: 10px;
  }
  .list-style li {
    margin-bottom: 6px;
  }
  .list-style li,
  p {
    font-size: 13px;
  }
}
</style>

<template>
  <div>
    <div
      class="navbar-custom"
      :class="{ isSticky: isSticky }"
      toggleable="lg"
      id="#navbar"
    >
      <b-container>
        <b-row class="align-items-center ">
          <b-col sm="12" md="4" class="text-center text-lg-left">
            <b-button
              @click="$parent.changePage('main')"
              class="btn btn-secondary btn-sm"
            >
              <i class="fas fa-angle-left"></i>
              Back
            </b-button>
          </b-col>
          <b-col sm="12" md="4">
            <div class="navbar-logo customer-logo text-center">
              <a class="d-inline-block" href="https://spendid.io">
                <img alt="logo" src="D-logo.png" class="light-logo" />
                <img alt="logo" src="L-logo.png" class="dark-logo" />
              </a>
            </div>
          </b-col>
          <b-col sm="12" md="4" class="text-center text-lg-right">
            <b-button class="btn light-btn-success btn-sm">
              HOW TO
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container class="py-2 py-md-4 mt-3">
      <b-row>
        <b-col md="12" xl="12">
          <div class="learn-heading text-center mb-3 mb-lg-5">
            <h4 class="mb-2">
              How to use the MyBudgetReport Predictive Budgeting Application
            </h4>
            <p class="m-0">
              <i>Powered by SPENDiD</i>
            </p>
          </div>
          <div class="leranpart mb-3 mb-md-4">
            <div class="learn-subheading">
              <h2><u>PROFILE</u></h2>
              <h5>
                Enter your “Profile” information through the
                <span class="h4 m-0 font-weight-bold"
                  ><u>Onboarding Interview</u></span
                >
                (or directly in the app if you’ve completed the Onboarding
                Interview earlier):
              </h5>
            </div>
            <ul class="list-style pl-3 pl-md-4">
              <li>
                <b><u>Zip Code</u></b> where you live
              </li>
              <li>
                Your <b><u>Age</u></b>
              </li>
              <li>
                <b>#</b> of people in your <b><u>Household</u></b>
              </li>
              <li>
                Whether you <b><u>Rent or Own</u></b> your home
              </li>

              <li>
                <b>Rent or Mortgage</b> payment each month
                <i
                  >(<b><u>including</u></b> Property Tax, Insurance, and any HOA
                  dues)</i
                >
              </li>
              <li>
                <b><u>Car</u></b> (or any vehicle) <b><u>Payments</u></b>
              </li>

              <li>
                <b><u>Other Debt Payments</u></b
                >(NOT balance owed) This includes credit card debt, student
                loans, home equity line payments, alimony or child support, tax
                estimates, etc…
              </li>

              <li>
                <b><u> Net Take Home Pay </u></b>
                <i>(after taxes & deductions)</i> from all sources
                <ul style="padding-left: 30px; margin-top: 10px;">
                  <li>
                    Select the <u><b>Frequency</b></u> (how often) each income
                    source is received
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="leranpart mb-3 mb-md-4">
            <div class="learn-subheading">
              <h2><u>MyBudgetReport App</u></h2>
              <p>
                <b
                  >After completing the Onboarding Interview, User will be taken
                  to the MyBudgetReport App with the Results section in view.
                  The Onboarding Interview has populated all the Profile and
                  Major Expenses Sections elements.
                </b>
              </p>
              <p>
                <b
                  >Note the Section Headers at the top of the App where you can
                  choose which section you wish to view or potentially edit.
                </b>
              </p>
            </div>
          </div>

          <!-- <div class="leranpart mb-3 mb-md-4">
                <div class="learn-subheading">
                    <h2>MAJOR EXPENSES</h2>
                    <h5>Enter your Monthly “Major Expense” Category amounts:</h5>
                </div>
                <ul class="list-style pl-3 pl-md-4">
                    <li>
                        <b><u>Rent or Mortgage</u></b> payment each month (<b><u><i>including</i></u></b> <i>&nbsp; Property Tax, Insurance, and any HOA dues</i> )
                    </li>
                    <li>
                        <b><u>Car</u></b> (or any vehicle) <b><u>Payments</u></b>
                    </li>
                    <li>
                        <b><u>Other Debt Payments</u></b> (not balance owed) including credit card debt, student loans, home equity line payments, alimony or child support, tax estimates, etc…
                    </li>
                </ul>
            </div> -->

          <div class="leranpart mb-3 mb-md-4">
            <div class="learn-subheading">
              <h2><u>COMMON MONTHLY BILLS</u></h2>
              <h5>
                Edit amounts for any of the six categories for Common Monthly
                Bills
              </h5>
            </div>
            <ul class="list-style pl-3 pl-md-4">
              <li>
                You may know a more precise amount than
                <b>MyBudgetReport’s</b> predicted figure. For example, your
                <b>Utilities-Power Bill</b> might be a known amount different
                from what MyBudgetReport has expected. Just enter your preferred
                amount, and MyBudgetReport will use it in all other
                calculations. (these will appear with a light blue background)
              </li>
            </ul>
          </div>
          <div class="leranpart mb-3 mb-md-4">
            <div class="learn-subheading">
              <h2><u>FOOD & OTHER EXPENSES</u></h2>
              <h5>
                Remove
                <i
                  class="far fa-times-circle text-danger"
                  aria-hidden="true"
                ></i>
                any Food & Other Expense Categories that don't apply to you.
              </h5>
            </div>
            <ul class="list-style pl-3 pl-md-4">
              <li>
                You can easily <b><u>Restore</u></b> a Removed category at any
                time from the <b>Removed Categories</b> section
              </li>
            </ul>
            <div class="learn-subheading">
              <h5>
                Edit any of these Other Expense Categories to a Fixed Amount you
                know to be true for you
              </h5>
            </div>
            <ul class="list-style pl-3 pl-md-4">
              <li>(Same logic as for <b>Common Monthly Bills</b> section)</li>
            </ul>
          </div>

          <div class="leranpart mb-3 mb-md-4">
            <div class="learn-subheading">
              <h2><u>RESULTS</u></h2>
              <h5>
                Once you've completed these simple steps, it's time to review
                your Results.
              </h5>
            </div>
            <p>
              Your <b>SPENDiD Budget Health Score</b> displayed in the Results
              section of the application is an easy-to-understand indicator of
              your overall cash flow health. This Score is also a powerful
              decision-making metric that can help forecast the budget stress a
              potential expense commitment might cause for you.
            </p>
            <p>
              Built on the familiar 1-100 and grades of A-F that everyone
              understands, obviously the higher your
              <b>SPENDiD Budget Health Score </b> the better. A score above 80
              indicates you should be able to have positive cash flow during
              most months.
            </p>
            <p>
              Based on your Predicted Saving Ability,
              <b>MyBudgetReport </b> creates proposed budget amounts for all
              Expense Categories that you did NOT input a known amount.
            </p>
            <div class="learn-subheading">
              <h2><u>ACTIONS YOU CAN TAKE</u></h2>
              <h5>
                With these simple metrics and unique insights from your
                <b>Results</b>:
              </h5>
            </div>
            <ul class="list-style pl-3 pl-md-4">
              <li>
                If you have a strong <b>SPENDiD Score</b>, can you increase your
                Amount to Savings and start an automated draft to a separate
                rainy-day account? Or maybe it’s time to increase your 401(k)
                withholding?
              </li>
              <li>
                If your <b>SPENDiD Budget Health Score</b> seems much lower than
                you expected, first be sure you’ve removed any expense
                categories that don’t apply to you. For example, if your share
                of Health Insurance premiums is already deducted from your
                paycheck, you should be sure to zero the amount for this expense
                category. Don’t have a pet? Then remove that category, and so
                on.
              </li>
              <li>
                Also, if you’ve entered a fixed amount for any
                <b>Common Monthly Bills or Food & Other Expense Categories</b>,
                be sure you entered the amounts correctly and with the right
                <b><u>Frequency</u></b
                >.
              </li>
              <li>
                Next, are any of the Fixed Expenses you input higher than your
                peers? These are your first <b>Opportunities</b> to look into
                and take action. Click on any of these
                <b>“Opportunity” bars</b> which will take you to that Expense
                tile. If the amount you have input is correct, click on the red
                <b><u>“Ideas</u></b
                >button. This takes you to helpful resources on that specific
                topic. We update these articles frequently, so returning for
                more knowledge each month is wise. For example, is it time to
                consider a lower-cost home or apartment, take in a roommate for
                a while to share expenses, or get out from under that new truck
                payment you regret? Or maybe find help refinancing your
                high-interest debt?
              </li>
              <!-- <li>
                        Maybe the best way to boost your SPENDiD Score and Predicted Saving Ability is with more <b>Income</b>. Can you get creative with a “side-gig” or work-from-home hustle at night? Or if you know you deserve it, ask for that raise to help ease your stress - your employer will benefit from your hard work even more.
                    </li> -->
            </ul>

            <div class="leranpart mb-3 mb-md-4">
              <div class="learn-subheading">
                <h2>Your Budget Model</h2>
                <ul class="list-style pl-3 pl-md-4">
                  <li>
                    <b>50% Toward Needs</b>
                    <p>
                      This budget approach states that you should spend 50% of
                      the money you earn on necessary items, such as housing,
                      transportation, and other essential bills. The items in
                      this category cover the basics of life. They’re the things
                      you need to survive at your current standard of living.
                    </p>
                  </li>
                  <li>
                    <b>30% Toward Wants</b>
                    <p>
                      This is what some people think of as the “fun” category.
                      It includes things you want but could certainly live
                      without.
                    </p>
                  </li>
                  <li>
                    <b>20% Toward Financial Goals</b>
                    <p>
                      The next number to think about in this budget formula is
                      20%. This is the money that goes toward achieving your
                      financial goals, which may include:
                    </p>
                  </li>
                  <li>
                    <a
                      href="https://www.thewaystowealth.com/save-money/how-to-build-an-emergency-fund/"
                      target="_blank"
                      ><u>Building an emergency fund</u></a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.thewaystowealth.com/debt-payoff/get-out-of-debt-fast/"
                      target="_blank"
                      ><u>Paying off high-interest debt</u></a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="learn-subheading">
              <h2>Brief, Repeat Engagement With MyBudgetReport Is Critical</h2>
            </div>
            <p>
              Plan to spend a few minutes with <b>MyBudgetReport</b> AT LEAST
              MONTHLY to check in on your
              <b>SPENDiD Budget Health Score </b> and
              <b>Predicted Saving Ability</b>. This will keep you aware of
              potential steps that are most applicable to YOU. We update our
              database often, which will reflect in your scores. But also,
              things change for you. For example, you'll want to update
              <b>MyBudgetReport </b> with any change in your
              <b>Take-Home Income</b> or a <b>Major Fixed Expense</b>.
            </p>
            <p>
              Most importantly, use <b>MyBudgetReport </b>
              <b><u>before</u></b> you make a major expense decision. Try
              “what-if?” scenarios you’re considering, such as moving to a
              different zip code, purchasing a vehicle, or increasing your
              savings.
            </p>
            <div class="learn-subheading">
              <div class="learn-heading">
                <h2>AND REMEMBER:</h2>
                <h4>
                  MyBudgetReport is your “go-to” resource to help you make
                  smarter and more informed financial decisions impacting your
                  debt levels and saving ability. With just a few minutes of
                  monthly engagement, you can enjoy greater financial peace of
                  mind, lower stress, and a healthier and more fulfilling life.
                </h4>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <Footer />
  </div>
</template>
